export const FIELD_SESSION_PAGE_SIZE = 10;
export const FIELD_SESSION_PAGES_PARAM = 'pages';

export function parseFieldSessionPages(value: string | null) {
  const pages = Number(value);

  return Number.isInteger(pages) && pages > 0 ? pages : 1;
}
